import { ROUTE_NAMES } from './routeNames.const'

export const routesOnboarding = {
  path: '/onboarding/:step?',
  name: ROUTE_NAMES.onboarding,
  component: () =>
    import(
      /* webpackChunkName: "Onboarding" */ 'src/pages/Onboarding/Onboarding.vue'
    ),
  props: true,
}
